import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import axios from 'axios';
import jsPDF from 'jspdf';
import { GET_ONE_EMPLOYEE_URL } from '../../../../../../services/api/shared/employees/EmployeesUrl';
import { GET_AGENT_SCORE_URL } from '../../../../../../services/api/customer-support/quality-assurance/QualityAssuranceUrl';
import { getUser } from '../../../../../../actions/shared/user/UserActions';

let autoTable;
try {
  autoTable = require('jspdf-autotable').default;
} catch (e) {
  autoTable = require('jspdf-autotable');
}

class PersonnelSendReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      from: '',
      to: '',
      employee: '',
      isGenerating: false
    };

    this.onChange = this.onChange.bind(this);
  }

  static propTypes = {
    getEmployeesInCustomerSupport: PropTypes.func.isRequired,
    employees: PropTypes.object.isRequired,
  };

  onChange = (e) => {
    if (e.target.type === 'checkbox') {
      // For checkbox, toggle the employee selection
      this.setState({
        employee: e.target.checked ? e.target.value : ''
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  componentDidMount() {
    this.props.getUser();
  }

  calculateTotalScore = (row) => {
    const scoreFields = [
      'knowledge',
      'resolution', 
      'greetings',
      'communtication_skills',
      'problem_solving',
      'process_adherence',
      'closing',
      'customer_experience',
      'retention_pitch',
      'listening_skills',
      'retention_drive'
    ];
    
    return scoreFields.reduce((total, field) => {
      const value = parseFloat(row[field]) || 0;
      return total + value;
    }, 0);
  };

  calculateAveragePercentage = (scoreData) => {
    if (!scoreData || scoreData.length === 0) return 0;
    
    const totalScores = scoreData.map(row => this.calculateTotalScore(row));
    const sum = totalScores.reduce((acc, score) => acc + score, 0);
    const average = sum / totalScores.length;
    
    const maxPossibleScore = 100;
    const percentage = (average / maxPossibleScore) * 100;
    
    return Math.round(percentage * 100) / 100;
  };

  createTransposedPDFManually = (doc, employeeData, scoreData) => {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    
    doc.setFontSize(16);
    doc.text(`${employeeData.firstName} ${employeeData.lastName} - Quality Report`, 20, 15);
    
    const dates = scoreData.map(row => row.created_at ? row.created_at.substring(0, 10) : 'N/A');
    
    const scoreFields = [
      { key: 'extension', label: 'Extension' },
      { key: 'knowledge', label: 'Knowledge' },
      { key: 'resolution', label: 'Resolution' },
      { key: 'greetings', label: 'Greetings' },
      { key: 'communtication_skills', label: 'Communication Skills' },
      { key: 'problem_solving', label: 'Problem Solving' },
      { key: 'process_adherence', label: 'Process Adherence' },
      { key: 'closing', label: 'Closing' },
      { key: 'customer_experience', label: 'Customer Experience' },
      { key: 'retention_pitch', label: 'Retention Pitch' },
      { key: 'listening_skills', label: 'Listening Skills' },
      { key: 'retention_drive', label: 'Retention Drive' },
      { key: 'total', label: 'Total Score' },
      { key: 'feedback', label: 'Feedback' },
      { key: 'average', label: 'Average %' }
    ];
    
    const startX = 15;
    const startY = 25;
    const labelColWidth = 55;
    const availableWidth = pageWidth - startX - labelColWidth - 15;
    const dataColWidth = Math.min(availableWidth / dates.length, 60); 
    const rowHeight = 10;
    const feedbackRowHeight = 35; 
    
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    
    doc.text('Score Category', startX, startY);
    dates.forEach((date, index) => {
      const x = startX + labelColWidth + (index * dataColWidth);
      if (x + dataColWidth <= pageWidth - 15) {
        doc.text(date, x, startY);
      }
    });
    
    doc.line(startX, startY + 3, Math.min(pageWidth - 15, startX + labelColWidth + (dates.length * dataColWidth)), startY + 3);
    
    doc.setFont(undefined, 'normal');
    let currentY = startY + 12;
    
    scoreFields.forEach((field, rowIndex) => {
      const isLastRow = rowIndex === scoreFields.length - 1;
      let currentRowHeight = field.key === 'feedback' ? feedbackRowHeight : rowHeight;
      
      doc.setFont(undefined, 'bold');
      doc.text(field.label, startX, currentY);
      doc.setFont(undefined, 'normal');
      
      if (field.key === 'average') {
        const avgPercentage = this.calculateAveragePercentage(scoreData);
        doc.setFont(undefined, 'bold');
        doc.text(`${avgPercentage}%`, startX + labelColWidth + 5, currentY);
        doc.setFont(undefined, 'normal');
      } else {
        scoreData.forEach((row, dateIndex) => {
          const x = startX + labelColWidth + (dateIndex * dataColWidth);
          if (x + dataColWidth <= pageWidth - 15) {
            let value = '';
            
            if (field.key === 'total') {
              value = this.calculateTotalScore(row).toString();
              doc.setFont(undefined, 'bold');
            } else if (field.key === 'feedback') {
              value = row[field.key] || '';
              const feedbackWidth = dataColWidth - 5; 
              const lines = doc.splitTextToSize(value, feedbackWidth);
              const lineHeight = 3;
              const totalTextHeight = lines.length * lineHeight;
              const minHeight = feedbackRowHeight;
              currentRowHeight = Math.max(minHeight, totalTextHeight + 10); 
              
              lines.forEach((line, lineIndex) => {
                doc.text(line, x + 2, currentY + (lineIndex * lineHeight)); 
              });
              doc.setFont(undefined, 'normal');
              return;
            } else {
              value = row[field.key] ? row[field.key].toString() : '0';
            }
            
            if (field.key !== 'feedback') {
              const maxLength = Math.floor(dataColWidth / 1.5); 
              const displayValue = value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
              doc.text(displayValue, x, currentY);
            }
            
            if (field.key === 'total') {
              doc.setFont(undefined, 'normal');
            }
          }
        });
      }
      
      const lineY = currentY + (currentRowHeight - 6);
      doc.line(startX, lineY, Math.min(pageWidth - 15, startX + labelColWidth + (dates.length * dataColWidth)), lineY);
      
      currentY += currentRowHeight;
    });
    
    const tableHeight = currentY - startY + 5;
    doc.line(startX, startY - 5, startX, startY - 5 + tableHeight);
    doc.line(startX + labelColWidth, startY - 5, startX + labelColWidth, startY - 5 + tableHeight);
    
    dates.forEach((date, index) => {
      const x = startX + labelColWidth + ((index + 1) * dataColWidth);
      if (x <= pageWidth - 15) {
        doc.line(x, startY - 5, x, startY - 5 + tableHeight);
      }
    });
  };

  sendReport = async () => {
    const { from, to, employee } = this.state;

    if (!from || !to || !employee) {
      toastr.info('Please select the employee, from and to date of the report you want');
      return;
    }

    this.setState({ isGenerating: true });

    const data = {
      from,
      to,
    };

    try {
      // Get employee details
      const employeeRes = await axios.get(`${GET_ONE_EMPLOYEE_URL}/${employee}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (!employeeRes.data) {
        toastr.error('Employee data not found');
        this.setState({ isGenerating: false });
        return;
      }

      // Get agent score data
      const scoreRes = await axios.post(`${GET_AGENT_SCORE_URL}/${employee}`, data, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });

      if (!scoreRes.data || (Array.isArray(scoreRes.data) && scoreRes.data.length === 0)) {
        toastr.warning(`No score data found for ${employeeRes.data.firstName} ${employeeRes.data.lastName} in the selected date range`);
        this.setState({ isGenerating: false });
        return;
      }

      // Create PDF in landscape mode exactly like the first file
      const doc = new jsPDF('landscape');
      const scoreData = Array.isArray(scoreRes.data) ? scoreRes.data : [scoreRes.data];

      try {
        const dates = scoreData.map((row, index) => 
          row.created_at ? row.created_at.substring(0, 10) : `Record ${index + 1}`
        );
        
        const scoreFields = [
          { key: 'extension', label: 'Extension' },
          { key: 'knowledge', label: 'Knowledge' },
          { key: 'resolution', label: 'Resolution' },
          { key: 'greetings', label: 'Greetings' },
          { key: 'communtication_skills', label: 'Communication Skills' },
          { key: 'problem_solving', label: 'Problem Solving' },
          { key: 'process_adherence', label: 'Process Adherence' },
          { key: 'closing', label: 'Closing' },
          { key: 'customer_experience', label: 'Customer Experience' },
          { key: 'retention_pitch', label: 'Retention Pitch' },
          { key: 'listening_skills', label: 'Listening Skills' },
          { key: 'retention_drive', label: 'Retention Drive' },
          { key: 'total', label: 'Total Score' },
          { key: 'feedback', label: 'Feedback' },
          { key: 'average', label: 'Average %' }
        ];

        const headers = ['Score Category', ...dates];
        
        const tableBody = scoreFields.map(field => {
          const row = [field.label];
          
          if (field.key === 'average') {
            const avgPercentage = this.calculateAveragePercentage(scoreData);
            row.push(`${avgPercentage}%`);
            for (let i = 1; i < dates.length; i++) {
              row.push('');
            }
          } else {
            scoreData.forEach(dataRow => {
              if (field.key === 'total') {
                row.push(this.calculateTotalScore(dataRow).toString());
              } else if (field.key === 'feedback') {
                const feedback = dataRow[field.key] || '';
                row.push(feedback);
              } else {
                row.push(dataRow[field.key] ? dataRow[field.key].toString() : '0');
              }
            });
          }
          
          return row;
        });

        if (doc.autoTable) {
          doc.autoTable({
            head: [headers],
            body: tableBody,
            startY: 20,
            margin: { top: 10, left: 10, right: 10 },
            styles: { 
              fontSize: 7,
              cellPadding: 1.5,
              overflow: 'linebreak',
              cellWidth: 'auto' 
            },
            headStyles: {
              fillColor: [41, 128, 185],
              textColor: 255,
              fontStyle: 'bold',
              fontSize: 5
            },
            columnStyles: {
              0: { 
                cellWidth: 120,
                fontStyle: 'bold',
                fillColor: [236, 240, 241]
              }
            },
            didParseCell: function (data) {
              if (data.row.index === 12 && data.column.index > 0) {
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fillColor = [255, 255, 204];
              }
              if (data.row.index === 14) {
                data.cell.styles.fontStyle = 'bold';
                data.cell.styles.fillColor = [204, 255, 204];
              }
              
              if (data.row.index === 13) {
                data.cell.styles.minCellHeight = 25; 
                data.cell.styles.valign = 'top';
                data.cell.styles.cellWidth = 'auto'; 
                data.cell.styles.overflow = 'linebreak'; 
              }
            },
            tableWidth: 'auto',
            theme: 'grid'
          });
          
          doc.setFontSize(16);
          doc.text(`${employeeRes.data.firstName} ${employeeRes.data.lastName} - Quality Report`, 20, 15);
        } else {
          toastr.Error('autoTable not available');
        }
        
      } catch (autoTableError) {
        this.createTransposedPDFManually(doc, employeeRes.data, scoreData);
      }

      // Save the PDF
      const fileName = `${employeeRes.data.firstName}_${employeeRes.data.lastName}_report.pdf`;
      doc.save(fileName);

      // Reset form
      this.setState({
        employee: '',
        from: '',
        to: '',
        isGenerating: false
      });

      toastr.success("Report generated successfully!");

    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        toastr.error(`API Error: ${error.response.data.message}`);
      } else {
        toastr.error(`Error: ${error.message}`);
      }
      this.setState({ isGenerating: false });
    }
  };

  render() {
    const { from, to, employee, isGenerating } = this.state;
    const { profile } = this.props;
    const { firstName, lastName, extension, id } = profile;

    return (
      <div
        id="send-report"
        className="modal fade in"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-center" id="myModalLabel">
                Send Report
              </h4>
              <button 
                type="button" 
                className="close" 
                data-dismiss="modal" 
                aria-hidden="true"
                disabled={isGenerating}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 d-flex mb-4 p-0">
                <div className="mr-5">
                  <label className="copy-font m-0 p-0">From</label>
                  <input 
                    type="date" 
                    className="form-control" 
                    name="from" 
                    value={from} 
                    onChange={this.onChange}
                    disabled={isGenerating}
                  />
                </div>

                <div className="ml-auto">
                  <label className="copy-font m-0 p-0">To</label>
                  <input 
                    type="date" 
                    className="form-control" 
                    name="to" 
                    value={to} 
                    onChange={this.onChange}
                    disabled={isGenerating}
                  />
                </div>
              </div>
              <table className="table score-agent-table copy-font">
                <thead>
                  <tr>
                    <th>Select Agent</th>
                    <th className="text-right">Extension</th>
                  </tr>
                </thead>
                {id ? (
                  <tbody>
                    <tr>
                      <td>
                        <div className="d-flex">
                          <input
                            type="checkbox"
                            className="mt-1 mr-5"
                            name="employee"
                            value={id}
                            checked={employee === id.toString()}
                            onChange={this.onChange}
                            disabled={isGenerating}
                          />
                          <h6>
                            {firstName} {lastName}
                          </h6>
                        </div>
                      </td>
                      <td className="text-right">
                        <h6>{extension}</h6>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan="2" className="text-right">
                        <button 
                          className="btn btn-green" 
                          type="submit" 
                          onClick={this.sendReport}
                          disabled={!employee || !from || !to || isGenerating}
                        >
                          {isGenerating ? 'Generating Report...' : 'Send Report'}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.user.user,
});

export default connect(mapStateToProps, { getUser })(PersonnelSendReport);